module.exports = __webpack_public_path__ + "static/media/109.86991736.mp3";